import React, { Component } from 'react'
import { Footer as MaterialFooter } from 'react-materialize'

class Footer extends Component {
  render() {
    return (
      <MaterialFooter copyrights="inPhoenix 2019 - inChatBot v0.2b"
              links={
                <ul>
                  <li><a className="grey-text text-lighten-3" href="http://github.com/inPhoenix">GitHub</a></li>
                </ul>
              }
              className='exampleFooter'
      >
        <h5 className="white-text">inChatBot</h5>
        <p className="grey-text text-lighten-4">Our bot is available 24/7</p>
      </MaterialFooter>
    )
  }
}

export default Footer
